/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import {
	htmlspecialchars,
	htmlspecialchars_decode,
	addslashes,
} from './util.js';

/**
 * Get translated string for given tag.
 * @param {string} tag
 * @param {string} [quotes]
 * @param {string} [fallbackString]
 * @example import { mjt } from './i18ntexts.js';
 * 			var string = mjt('tag');
 * @return {string}
 **/
export function mjt( tag, quotes, fallbackString ) {
	if( !window.mji18ntexts ) {
		throw new Error('window.mji18ntexts is not defined yet - you probably called mjt'+'() before text data was loaded.');
		// // eslint-disable-next-line
		// console.log('window.mji18ntexts is not defined yet - you probably called mjt'+'() before text data was loaded.');
		// return 'unknownyet';
	}
	if( !window.mji18ntexts.hasOwnProperty(tag) ) {
		if( typeof fallbackString === 'undefined' ) {
			// throw new Error('unknown locale tag: '+tag);
			// eslint-disable-next-line
			console.log('WARN: mjt() called with unknown locale tag: '+tag);
		}
		return fallbackString || ('translation-missing:'+tag+'');
	}
	var text = window.mji18ntexts[tag];
	if( typeof quotes === 'undefined' ) {
		// this is what the template engine would do by default ...
		//quotes = '+';
		return htmlspecialchars(text);
	} else if( quotes === '!' ) {
		//quotes = '+!'; // = same as nothing
		return text;
	}
	// this is what the template engine would do by default ...
	quotes = '+'+quotes;
	for( var qi=0; qi<quotes.length; ++qi ) {
		var qc = quotes.charAt(qi);
		switch( qc ) {
		case '&':  text = htmlspecialchars(text,false,true); break;
		case '+':  text = htmlspecialchars(text); break;
		case '!':
			text = htmlspecialchars_decode(text);
			text = text.replace('<br />',"\n");
			break;
		case '\\':
			text = addslashes(text);
			//text = text.replace(/[\n]/g,'\\n');
			break;
		//case '%':  $v = urlencode($v); break;
		//case '-':  $v = rawurlencode($v); break;
		//case '#':  $v = intval($v,10); break;
		//case '.':  $v = _t_fmt_f2s($v,$skin->GetApp()->GetLocaleImpl()); break;
		default:
			throw new Error('quote type not implemented yet: '+qc);
		}
	}
	return text;
}

